"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var CropperImage_vue_1 = __importDefault(require("@/components/cropper-image/CropperImage.vue"));
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var PrivateView_1 = __importDefault(require("@/views/PrivateView"));
var UpdateUserData = /** @class */ (function (_super) {
    __extends(UpdateUserData, _super);
    function UpdateUserData() {
        var _this = _super.call(this) || this;
        _this.genderOptions = [];
        _this.validationState = {
            name: { state: null, message: null },
            surname: { state: null, message: null },
            country: { state: null, message: null },
            street: { state: null, message: null },
            city: { state: null, message: null },
            gender: { state: null, message: null },
            postal_code: { state: null, message: null },
            birth_date: { state: null, message: null },
            phone: { state: null, message: null }
        };
        _this.countriesAvailable = [];
        _this.formHasErrors = false;
        _this.uploadLoaderImage = false;
        _this.user = {
            email: '',
            name: '',
            surname: '',
            photo: null,
            password: '',
            country: null,
            street: null,
            phone: null,
            city: null,
            gender: null,
            postal_code: null,
            birth_date: null
        };
        return _this;
    }
    UpdateUserData.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, error_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.genderOptions = [
                            { value: null, text: this.$t('common.unspecified') },
                            { value: 'M', text: this.$t('common.male') },
                            { value: 'F', text: this.$t('common.female') },
                            { value: 'B', text: this.$t('common.binary') }
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        _a = this;
                        return [4 /*yield*/, this.$getAllCountriesAvailableService.request()];
                    case 2:
                        _a.countriesAvailable = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        return [4 /*yield*/, this.$router.push({ name: 'error', params: { code: error_1.response.status.toString() } })];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        this.$getUserDataService.request().then(function (response) {
                            _this.user = response;
                            _this.loader = false;
                            if (_this.user.photo) {
                                _this.$root.$emit('DEFAULT-USER-IMAGE-LOADED', _this.user.photo);
                            }
                        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status.toString() } }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    UpdateUserData.prototype.submit = function () {
        var _this = this;
        this.resetValidationState();
        this.formHasErrors = !this.validation();
        if (this.formHasErrors) {
            return;
        }
        if (this.user.birth_date === "") {
            this.user.birth_date = null;
        }
        this.$updateUserDataService.request(this.user).then(function () {
            _this.$router.push({ name: 'checkPartnership' });
            _this.$getUserDataService.clear();
            _this.$root.$emit('USER_DATA_UPDATED');
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    UpdateUserData.prototype.validation = function () {
        var _a;
        if (!this.user.name) {
            this.validationState.name.message = this.$t('validation.valueMandatory');
            return this.validationState.name.state = false;
        }
        if (!this.user.surname) {
            this.validationState.surname.message = this.$t('validation.valueMandatory');
            return this.validationState.surname.state = false;
        }
        if (((_a = this.user.phone) === null || _a === void 0 ? void 0 : _a.length) && !(/^[0-9]{1,20}$/).test(this.user.phone)) {
            this.validationState.phone.message = this.$t('validation.invalidPhone');
            return this.validationState.phone.state = false;
        }
        return true;
    };
    UpdateUserData.prototype.resetValidationState = function () {
        this.validationState.name = { state: null, message: null };
        this.validationState.surname = { state: null, message: null };
        this.validationState.country = { state: null, message: null };
        this.validationState.street = { state: null, message: null };
        this.validationState.city = { state: null, message: null };
        this.validationState.gender = { state: null, message: null };
        this.validationState.postal_code = { state: null, message: null };
        this.validationState.birth_date = { state: null, message: null };
        this.validationState.phone = { state: null, message: null };
    };
    /**
     * TODO: Create a superclass for common properties
     */
    UpdateUserData.prototype.onCropSuccessImage = function (file) {
        var _this = this;
        var formData = new FormData();
        formData.append('image', file);
        this.uploadLoaderImage = true;
        this.$uploadCroppedUserImageService.request(formData).then(function (response) {
            _this.user.photo = response;
            _this.uploadLoaderImage = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    UpdateUserData.prototype.onCropCancel = function () {
        this.user.photo = null;
    };
    UpdateUserData.prototype.deleteAccountConfirmation = function () {
        this.$bvModal.show('delete-account-confirm-modal');
    };
    UpdateUserData.prototype.deleteAccount = function () {
        var _this = this;
        this.$deleteAccountService.request().then(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$oAuth2.logout()];
                    case 1:
                        _a.sent();
                        window.location.reload();
                        return [2 /*return*/];
                }
            });
        }); }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    UpdateUserData = __decorate([
        vue_property_decorator_1.Component({
            name: 'UpdateUserData',
            components: {
                CropperImage: CropperImage_vue_1.default,
                Spinner: Spinner_vue_1.default,
                ViewWrapper: ViewWrapper_vue_1.default
            }
        })
    ], UpdateUserData);
    return UpdateUserData;
}(PrivateView_1.default));
exports.default = UpdateUserData;
